export default function encodeBase64(input, encoding = 'utf-8') {
  let bytes;

  if (encoding.toLowerCase() === 'windows-1252') {
    // ⚠️ Only works in browsers that support legacy encodings
    const encoder = new TextEncoder('windows-1252', {
      NONSTANDARD_allowLegacyEncoding: true,
    });
    bytes = encoder.encode(input);
  } else {
    // Default: UTF-8
    bytes = new TextEncoder().encode(input);
  }

  const binary = Array.from(bytes, (b) => String.fromCharCode(b)).join('');
  return btoa(binary);
}
